<template>
  <div>
    <v-container fluid pa-0 pt-3 ma-0 highlight v-if="false">
      <v-layout row justify-center text-xs-center>
        <v-flex xs2 pb-1>
          <router-link :to="{path: '/tutorials'}">
            <p><v-icon large>import_contacts</v-icon></p>
            <p class="title mt-1" style="color: rgba(0,0,0,0.54);">Tutorials</p>
          </router-link>
        </v-flex>
        <v-flex xs2 pb-1 style="border-bottom: 4px solid rgba(0,0,0,0.54);">
          <router-link :to="{path: '/ideas'}">
            <p><v-icon large style="transform: scaleY(-1);">wb_incandescent</v-icon></p>
            <p class="title mt-1" style="color: rgba(0,0,0,0.54);">Ideas</p>
          </router-link>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container pa-3 mt-3>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-text-field
            v-model="searchAC"
            clearable
            label="Search..."
            hide-details
            outline
          />
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid px-3 py-0 my-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <div>
            <v-chip
              v-for="manip in manips"
              :key="manip.id"
              @click="chipDidClick(manip)"
              :color="isChipActive(manip.id) ? 'accent' : undefined"
              :dark="isChipActive(manip.id)"
            >
              <div class="clickable">
                {{ manip.displayName }}
              </div>
            </v-chip>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid px-3 py-0 my-0>
      <v-layout mt-3 row wrap justify-start white--text :class="{'justify-center': $vuetify.breakpoint.xs}">
        <v-dialog v-model="displayTeachingIdeaVimeoDialog" :width="activeTeachingIdeaConfig.width" :height="activeTeachingIdeaConfig.height" white>
            <vimeo-player
              style="background: grey"
              v-if="displayTeachingIdeaVimeoDialog"
              :video-id="activeTeachingIdeaConfig.vimeoId"
              :options="{'muted':true, 'responsive':true, 'autoplay':true, 'loop':true}"
            />
        </v-dialog>
        <template
          v-for="idea in teachingIdeas"
        >
          <v-flex
            :key="idea.vimeoId"
            xs10
            sm6
            md4
            pa-3
            text-xs-center
            @click="playTeachingIdea(idea)"
          >
            <div class="ti">
              <img :src="'/ti-images/' + idea.thumb" class="elevation-3" style="width: 100%; background:white">
              <p class="title font-weight-normal primary--text" style="padding-top: 8px; padding-bottom: 14px;">
                {{ idea.title }}
              </p>
            </div>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import ideas from '@/data/ideas.js'
import m from '@/data/manips.js'
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
  data: function () {
    return {
      activeChips: [],
      displayTeachingIdeaVimeoDialog: false,
      activeTeachingIdeaConfig: {
        vimeoId: null,
        width: 256,
        height: 144,
        description: ''
      },
      manips: m,
      searchAC: null,
      searchInput: '',
      lastSearchInput: null,
      lastCustomSearch: null,
      searchTerm: null,
      searchPlaceholder: null
    }
  },
  components: {
    'vimeo-player': vueVimeoPlayer
  },
  computed: {
    teachingIdeas: function () {
      let ideasForActiveChips = null
      if (this.activeChips && this.activeChips.length > 0) {
        // filter the ideas list first
        ideasForActiveChips = _.filter(ideas, (idea) => {
          for (let i = 0; i < idea.manipulatives.length; i++) {
            const m = idea.manipulatives[i]
            const idx = this.activeChips.indexOf(m)

            if (idx !== -1) return true
          }

          return false
        })
      } else {
        ideasForActiveChips = ideas.concat()
      }

      // apply search terms to filtered items
      if (this.searchTerm) {
        const ideasWithTitlesForSearchTerm = _.filter(ideasForActiveChips, (idea) => {
          if (_.startsWith(idea.title, this.searchTerm)) return true
        })

        if (ideasWithTitlesForSearchTerm.length > 0) return ideasWithTitlesForSearchTerm

        // try searching on keywords instead
        return _.filter(ideasForActiveChips, (idea) => {
          for (let i = 0; i < idea.keywords.length; i++) {
            const keyword = idea.keywords[i]

            if (_.startsWith(keyword, this.searchTerm)) return true
          }

          return false
        })
      }

      return ideasForActiveChips
    }
  },
  watch: {
    searchAC: function (val) {
      this.searchTerm = val
    }
  },
  mounted: function () {
  },
  methods: {
    test: function () {
      const s = this.searchInput
      this.searchAC = s
      this.searchPlaceholder = s
    },
    playTeachingIdea: function (teachingIdea) {
      // calculate size
      const steps = [
        { width: 200, height: 150 },
        { width: 400, height: 300 },
        { width: 640, height: 480 },
        { width: 800, height: 600 },
        { width: 960, height: 720 },
        { width: 1024, height: 768 },
        { width: 1280, height: 960 }
      ]

      let ar = null
      for (const step of steps) {
        if (step.width < window.innerWidth && step.height < window.innerHeight) {
          ar = step
        }
      }

      ar = ar === null ? steps[0] : ar

      this.activeTeachingIdeaConfig = {
        vimeoId: teachingIdea.vimeoId,
        width: ar.width,
        height: ar.height,
        description: teachingIdea.description
      }

      this.displayTeachingIdeaVimeoDialog = true
    },
    chipDidClick: function (manip) {
      const idx = _.indexOf(this.activeChips, manip.id)

      if (idx === -1) {
        // push the entry
        this.activeChips.push(manip.id)
      } else {
        // remove the entry
        this.activeChips.splice(idx, 1)
      }
    },
    isChipActive: function (id) {
      const idx = _.indexOf(this.activeChips, id)

      return idx !== -1
    }
  }
}
</script>

<style scoped>
.ti {
  color: #000000;
  padding:0px;
  cursor: pointer;
}

.clickable {
  cursor: pointer;
}
</style>
